export const MIN_IMAGE_WIDTH = 40;

/**
 * Compute a new image width during a drag-resize, clamped to sensible bounds.
 *
 * @param {number} startWidth - image width (px) when the drag started
 * @param {number} deltaX - horizontal pointer movement (px) since drag start
 * @param {number} maxWidth - maximum allowed width (px), e.g. the container width
 * @returns {number} the clamped, rounded width in pixels
 */
export const clampImageWidth = (startWidth, deltaX, maxWidth) => {
  const upperBound = maxWidth && maxWidth > MIN_IMAGE_WIDTH ? maxWidth : Infinity;
  const next = startWidth + deltaX;
  return Math.round(Math.min(Math.max(next, MIN_IMAGE_WIDTH), upperBound));
};
